import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {

  @Input()
  message!: string;
  showMore = false;

  @Input() isUser!: boolean;

  originalMessage!: string;

  ngOnInit() {
    // check letnth of message if moe than 20 then show only 20 characters and add more
    if (!this.isUser) {
      this.originalMessage = this.message;
      this.message = this.message.length > 650 ? this.message.substring(0, 650) + '...' : this.message;

      if (this.message.length > 650) {
        this.showMore = true;
      }
    }
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
    this.message = this.showMore ? this.message.substring(0, 650) + '...' : this.originalMessage;
  }

}
